"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative"
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    marginLeft: theme.spacing(-.5),
    marginRight: theme.spacing(-.5)
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 0,
    margin: theme.spacing(.5),
    border: "1px solid",
    minWidth: theme.spacing(24),
    width: theme.spacing(24),
    height: theme.spacing(24),
    marginBottom: theme.spacing(4.5),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(32),
      width: theme.spacing(32),
      height: theme.spacing(32)
    }
  }
}));

const PrimusMediaUpload = ({
  accept,
  multiple,
  onUpload,
  children
}) => {
  return _react.default.createElement(_reactDropzone.default, {
    multiple: multiple,
    accept: accept,
    onDrop: event => onUpload(event)
  }, ({
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  }) => _react.default.createElement("div", getRootProps(), _react.default.createElement("input", getInputProps()), children));
};

const PrimusMediaButton = (_ref) => {
  let label = _ref.label,
      onClick = _ref.onClick,
      onUpload = _ref.onUpload,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "onClick", "onUpload"]);

  const classes = useStyles();

  if (onUpload) {
    return _react.default.createElement(PrimusMediaUpload, {
      onUpload: onUpload
    }, _react.default.createElement(_Button.default, {
      variant: "outlined",
      color: "primary",
      className: classes.button
    }, _react.default.createElement(_Add.default, null)));
  }

  return _react.default.createElement(_Button.default, {
    variant: "outlined",
    color: "primary",
    className: classes.button,
    onClick: onClick
  }, _react.default.createElement(_Add.default, null));
};

const PrimusMedia = ({
  formData = [],
  buttons = [],
  children
}) => {
  const classes = useStyles();

  if (!formData.length) {
    return _react.default.createElement("section", {
      className: classes.root
    }, _react.default.createElement("div", {
      className: classes.grid
    }, buttons && buttons.map((button, index) => {
      return _react.default.createElement(PrimusMediaButton, _extends({}, button, {
        key: index
      }));
    })));
  }

  return _react.default.createElement("section", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.grid
  }, children, buttons && buttons.map((button, index) => {
    return _react.default.createElement(PrimusMediaButton, _extends({}, button, {
      key: index
    }));
  })));
};

var _default = PrimusMedia;
exports.default = _default;
module.exports = exports.default;